import { render } from "./device-details-overview.vue?vue&type=template&id=2360e7ba&scoped=true&ts=true"
import script from "./device-details-overview.ts?vue&type=script&lang=ts"
export * from "./device-details-overview.ts?vue&type=script&lang=ts"

import "./device-details-overview.scss?vue&type=style&index=0&id=2360e7ba&scoped=true&lang=scss"

import exportComponent from "/builds/elichens-avolta-connect/software/avolta-dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2360e7ba"]])

export default __exports__